import { render, staticRenderFns } from "./ChartFrame.vue?vue&type=template&id=394f6738&scoped=true&"
import script from "./ChartFrame.vue?vue&type=script&lang=js&"
export * from "./ChartFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394f6738",
  null
  
)

export default component.exports